import { render, staticRenderFns } from "./SettingsAccordion.vue?vue&type=template&id=58c53f51&scoped=true&"
import script from "./SettingsAccordion.vue?vue&type=script&lang=js&"
export * from "./SettingsAccordion.vue?vue&type=script&lang=js&"
import style0 from "./SettingsAccordion.vue?vue&type=style&index=0&id=58c53f51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c53f51",
  null
  
)

export default component.exports